import { render, staticRenderFns } from "./productNoticeList.vue?vue&type=template&id=287639b9&scoped=true"
import script from "./productNoticeList.vue?vue&type=script&lang=ts"
export * from "./productNoticeList.vue?vue&type=script&lang=ts"
import style0 from "./productNoticeList.vue?vue&type=style&index=0&id=287639b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287639b9",
  null
  
)

export default component.exports